import React, { useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const boxStyle = {
  width: "35px",
  height: "35px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "3px",
  margin: "0 3px",
  backgroundColor: "transparent",
  border: "1px solid #ddd",
  cursor: "pointer",
};
const dotStyle = {
  width: "35px",
  height: "35px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "0 3px",
  fontWeight: "bold",
  color: "#ddd",
  fontSize: "30px",
};
const disableStyle = {
  ...boxStyle,
  cursor: "not-allowed",
  border: "1px solid #ddd",
  color: "#ddd",
};
const contentStyles = {
  display: "flex",
  flexDirection: "row",
};
const containerStyles = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
};
const LAST_FIX_PAGE_NUM = 5;

function Pagination(props) {
  const { total, current, limit, onChange, position } = props;
  const list = total ? [...Array(total).keys()] : [];
  const [lastShow, setLastShow] = useState(LAST_FIX_PAGE_NUM);

  function handleChange(pageNo) {
    if (pageNo === lastShow) {
      setLastShow((lastVal) => {
        return lastVal + 3;
      });
    }

    onChange(pageNo, limit);
  }

  function getContainerStyle() {
    if (!position) return containerStyles;
    if (position === "left") return containerStyles;
    if (position === "right")
      return { ...containerStyles, justifyContent: "flex-end" };
    if (position === "center")
      return { ...containerStyles, justifyContent: "center" };
  }

  const disableLeft =
    !current || !Number.isInteger(current) || current - 1 <= 0;
  const disableRight =
    !current || !Number.isInteger(current) || current + 1 > total;
  return (
    <div style={getContainerStyle()}>
      <div style={contentStyles}>
        <button
          disabled={disableLeft}
          onClick={() => handleChange(current - 1)}
          style={disableLeft ? disableStyle : boxStyle}
        >
          <LeftOutlined />
        </button>
        {list.map((el) => {
          const num = el + 1;
          if (num === lastShow + 1) return <p style={dotStyle}>...</p>;
          if (num > lastShow && num < list.length) return null;

          return (
            <button
              onClick={() => handleChange(num)}
              style={{
                ...boxStyle,
                border:
                  current === num ? "1px solid #1890ff" : "1px solid #ddd",
                color: current === num ? "#1890ff" : "#000",
              }}
            >
              {num}
            </button>
          );
        })}
        <button
          onClick={() => handleChange(current + 1)}
          disabled={disableRight}
          style={disableRight ? disableStyle : boxStyle}
        >
          <RightOutlined />
        </button>
      </div>
    </div>
  );
}

export default Pagination;
